const vaultColumnParser = (content: any): any[] => {
  const { columns } = content.data
  const columnsRequired = columns
  return (
    columnsRequired?.map((data: any) => {
      return {
        id: `${data?.businessName}`,
        isChecked: data?.required ?? false,
        title: data?.name ?? 'NA',
        isDisable: data?.required ?? false,
        rank: data?.rank ?? 1000,
      }
    }) ?? []
  ).sort((a: any, b: any) => a.rank - b.rank)
}

export { vaultColumnParser }
